var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGadash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 26,
    height: 34,
    viewBox: "0 0 26 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "prefix__a",
    d: "M5.371.508C2.758.508.64 2.626.64 5.238v13.894c0 1.941 1.574 3.516 3.516 3.516h16.06c1.944 0 3.517-1.575 3.517-3.516V5.24c0-2.613-2.118-4.731-4.731-4.731H5.372z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__c",
    d: "M6.11 9.108c-2.613 0-4.732 2.118-4.732 4.73v13.894c0 1.941 1.574 3.516 3.516 3.516h16.06c1.944 0 3.517-1.575 3.517-3.516V13.84c0-2.613-2.118-4.731-4.731-4.731H6.11z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(.562 1.163)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4A6354",
    d: "M13.778.234c2.287 1.566 2.169 4.016.755 5.442-.669.674-.984.67-1.637-.05-1.579-1.739-1.215-4.069.882-5.392"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#4A6354",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.215,
    d: "M13.778.234c2.287 1.566 2.169 4.016.755 5.442-.669.674-.984.67-1.637-.05-1.579-1.739-1.215-4.069.882-5.392z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4A6354",
    d: "M6.653 6.057c2.724-.51 4.373 1.305 4.381 3.314.005.95-.221 1.169-1.192 1.122-2.346-.113-3.736-2.018-3.189-4.436"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#4A6354",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.215,
    d: "M6.653 6.057c2.724-.51 4.373 1.305 4.381 3.314.005.95-.221 1.169-1.192 1.122-2.346-.113-3.736-2.018-3.189-4.436zM10.71 10.375c1.093.916 3.026 2.659 3.026 4.981"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4A6354",
    d: "M20.82 6.057c-2.725-.51-4.374 1.305-4.382 3.314-.004.95.222 1.169 1.192 1.122 2.346-.113 3.737-2.018 3.19-4.436"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#4A6354",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.215,
    d: "M20.82 6.057c-2.725-.51-4.374 1.305-4.382 3.314-.004.95.222 1.169 1.192 1.122 2.346-.113 3.737-2.018 3.19-4.436zM16.763 10.375c-1.093.916-3.026 2.659-3.026 4.981"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(.738 8.6)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "prefix__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#D1E040",
    d: "M.3 18.394c.178-.158 2.202-2.176 2.383-2.332 5.724-4.925 13.337-8.4 21.25-9.25.1.734.154 1.486.154 2.254v.044c-6.753 1.174-13.444 4.37-18.867 10.349-.151.167-4.43 4.962-4.58 5.133-1.028-.963-1.217-3.127-1.925-4.435l1.81-.867-.224-.896zm4.859 4.481c1.657.059 3.792-.27 5.258-.012 3.621-4.533 8.036-7.828 12.709-10.054.196-.094.793-.234.99-.324.17-.778-.116-1.533-.063-2.357-6.857 1.485-13.183 5.311-17.437 10.715l-.283.365-1.174 1.667zm7.79.142c2.428-.028 8.51 1.557 10.383.065 1.931-1.538.762-6.612.758-9.43 0-.195-.754.304-.697.12-4.278 2.239-7.47 5.438-10.444 9.245z",
    mask: "url(#prefix__b)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "prefix__d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__c"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#D1E040",
    d: "M11.382 18.138c-3.41-1.49-7.064-2.525-10.79-2.98C.473 15.914.41 16.69.4 17.483c2.59.49 5.166 1.277 7.661 2.41.693-.408 1.392-.792 2.092-1.151.407-.208.816-.41 1.228-.604zM.401 25.702c-.311-.663.217-3.214 0-3.936.65.352 1.96 1.27 2.587 1.665-.378.312-.751.63-1.119.958L.401 25.702zm0-4.667c-.171-.812.065-1.654.021-2.516 2.172.508 4.287 1.25 6.295 2.2-.96.616-1.904 1.28-2.823 1.99-1.03-.614-2.429-1.172-3.493-1.674z",
    mask: "url(#prefix__d)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#4A6354",
    strokeLinecap: "round",
    strokeWidth: 1.215,
    d: "M13.736 19.755L13.736 6.477",
    mask: "url(#prefix__d)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGadash);
export default __webpack_public_path__ + "static/media/gadash.cec0195e674a4540ea12e03904083cda.svg";
export { ForwardRef as ReactComponent };